$(document).ready(function () {
    const IDENTIFIER = "time_tracking_admin_tool";
    const pathShiftHtmlTable = "/action/time-tracking/shift-html-table";
    const pathSaveClocking = "/action/time-tracking/clocking";
    const pathGetClockingForm = "/action/time-tracking/clocking-form";
    const wrapper = $("div#" + IDENTIFIER + "_wrapper");
    const fetchShiftsHtmlTableButton = $("div#" + IDENTIFIER + "_filter_button");
    const filterStoreSelect = $("div#" + IDENTIFIER + "_filter_wrapper select.store_select");
    const modalParentElementInDOM = $('div#content');
    const clockingFormHeaderNewClocking = translate('time_tracking_admin_new_clocking');
    const errorTitle = translate('time_tracking_admin_error_occurred');
    const closeLabel = translate('close');
    const primaryButtonClasses = 'transition duration-200 border shadow-sm inline-flex items-center justify-center rounded-md px-6 py-2 text-sm font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none bg-primary border-primary text-white hover:bg-primary/90 hover:border-primary/90 disabled:opacity-70 disabled:cursor-not-allowed';

    let ajaxLockActive = false;

    initFilterFlatpickr();
    initClockingFlatpickr();
    initCommentTooltips();

    // Save clocking
    $(document).on('click', 'div#' + IDENTIFIER + '_wrapper div#' + IDENTIFIER + '_save_clocking_button', function () {
        if (ajaxLockActive){
            return false;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: pathSaveClocking,
            data: getClockingParameters(),
            dataType: 'json'
        }).success(function (data) {
            $('form#time_tracking_admin_tool_clocking_form').html(
                '<div class="rounded-lg border border-success/20 bg-success/20 px-4 py-3 text-sm text-success">' +
                    '<strong>' + translate('time_tracking_admin_clocking_saved') + '</strong>' +
                    '<div class="mt-5">' +
                        '<div id="get_new_clocking_form_button" class="' + primaryButtonClasses + '">' + clockingFormHeaderNewClocking + '</div>' +
                    '</div>' +
                '</div>'
            );
            refreshShiftTable();
        }).error(function (data) {
            let modalTitle = errorTitle;
            let modalMessage = $.parseJSON(data.responseText).errors;
            let modalAlertType = 'error';
            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, closeLabel, modalAlertType);
        }).always(function () {
            ajaxLockActive = false;
        });
    });

    // Get new clocking form
    $(document).on('click', 'div#' + IDENTIFIER + '_wrapper div#get_new_clocking_form_button', function () {
        if (ajaxLockActive){
            return false;
        }

        // Change form header
        $('div#time_tracking_admin_tool_wrapper div#clocking_form_header h1').html(clockingFormHeaderNewClocking);

        ajaxLockActive = true;

        getClockingForm(0);
        return false;
    });

    // Click on a shift to edit it
    $(document).on('click', 'div#' + IDENTIFIER + '_wrapper table#time_tracking_admin_tool_shift_table tr td', function () {
        if (ajaxLockActive){
            return false;
        }

        // Change form header
        $('div#time_tracking_admin_tool_wrapper div#clocking_form_header h1').html(translate('time_tracking_admin_edit_clocking'));

        ajaxLockActive = true;

        let parentTr = $(this).parent();
        getClockingForm(parentTr.attr("shift_id"));
        return false;
    });

    fetchShiftsHtmlTableButton.click(function (e) {
        if (ajaxLockActive){
            return false;
        }

        ajaxLockActive = true;
        refreshShiftTable();
    });

    function refreshShiftTable() {
        displayLoadingGifInButton()
        $.ajax({
            type: 'GET',
            url: pathShiftHtmlTable,
            data: getfilterParameters(),
            dataType: 'json'
        }).success(function (data) {
            removeLoadingGifFromButton();
            $("div#shift_table_wrapper").replaceWith(data.html_table);
            initCommentTooltips();
        }).error(function (data) {
            removeLoadingGifFromButton();

            let modalTitle = errorTitle;
            let modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, translate('time_tracking_admin_fetch_shifts_error'), closeLabel, modalAlertType);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function getClockingForm(shiftId) {
        let data = {};

        if (!isNaN(shiftId) && (shiftId * 1) > 0) {
            data.shift_id = shiftId;
        }
        $.ajax({
            type: 'GET',
            url: pathGetClockingForm,
            data: data,
            dataType: 'json'
        }).success(function (data) {
            $('form#time_tracking_admin_tool_clocking_form').replaceWith(data.clocking_form);
            initClockingFlatpickr();
        }).error(function (data) {
            let modalTitle = errorTitle;
            let modalMessage = $.parseJSON(data.responseText).errors;
            let modalAlertType = 'error';
            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, closeLabel, modalAlertType);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    /**
     * Returns parameters sent to controller
     *
     * @returns
     */
    function getfilterParameters() {
        let data = {
            from_date: getDateFromShiftTable(),
            to_date: getDateToShiftTable(),
            user_id: getUserIdShiftTable(),
        };

        if (filterStoreSelect.length) {
            data.store_sync_code = filterStoreSelect.val();
        }
        return data
    }

    /**
     * Returns parameters sent to controller
     *
     * @returns
     */
    function getClockingParameters() {
        let data = {
            shift_id: $('input#' + IDENTIFIER + '_clocking_shift_id').val(),
            time_from: $('input#' + IDENTIFIER + '_clocking_time_from').val(),
            time_to: $('input#' + IDENTIFIER + '_clocking_time_to').val(),
            user_id: $("form#time_tracking_admin_tool_clocking_form select.user_select").val(),
            comment: $("form#time_tracking_admin_tool_clocking_form textarea#time_tracking_admin_tool_clocking_comment").val(),
        };

        if (filterStoreSelect.length) {
            data.store_sync_code = $("form#time_tracking_admin_tool_clocking_form select.store_select").val();
        }
        return data
    }

    function initFilterFlatpickr() {
        initFlatpickr("div#" + IDENTIFIER + "_wrapper input.datepicker", {
            dateFormat: 'd/m/Y',
            allowInput: false,
            disableMobile: true
        });
    }

    function initClockingFlatpickr() {
        initFlatpickr("div#" + IDENTIFIER + "_wrapper input.datetimepicker", {
            enableTime: true,
            time_24hr: true,
            dateFormat: 'd/m/Y H:i',
            minuteIncrement: 5,
            allowInput: false,
            disableMobile: true
        });
    }

    function initFlatpickr(selector, options) {
        if (typeof flatpickr === 'undefined') {
            return;
        }

        $(selector).each(function () {
            destroyLegacyPicker(this);

            if (this._flatpickr) {
                this._flatpickr.destroy();
            }

            flatpickr(this, options);
        });
    }

    function destroyLegacyPicker(input) {
        if ($.fn.datepicker) {
            try {
                $(input).datepicker('destroy');
            } catch (e) {}
        }

        if ($.fn.datetimepicker) {
            try {
                $(input).datetimepicker('destroy');
            } catch (e) {}
        }

        $(input).removeClass('hasDatepicker').removeAttr('data-has-datepicker');
    }

    function initCommentTooltips() {
        $("div#" + IDENTIFIER + "_wrapper .time-tracking-comment-tooltip").each(function () {
            const nativeTitle = this.getAttribute('title');
            if (nativeTitle) {
                this.setAttribute('data-original-title', nativeTitle);
                this.removeAttribute('title');
            }

            if (typeof tippy === 'undefined') {
                return;
            }

            const message = this.getAttribute('data-tooltip-message') || this.getAttribute('data-original-title') || this.getAttribute('aria-label');

            if (!message) {
                return;
            }

            const content = document.createElement('div');
            content.style.whiteSpace = 'pre-line';
            content.textContent = message;

            if (this._tippy) {
                this._tippy.setContent(content);
                return;
            }

            tippy(this, {
                content: content,
                arrow: typeof roundArrow !== 'undefined' ? roundArrow : true,
                animation: 'shift-away',
                placement: this.getAttribute('data-placement') || 'top',
                trigger: 'mouseenter focus',
                delay: [0, 0]
            });
        });
    }

    function getDateFromShiftTable() {
        return $("input#" + IDENTIFIER + "_filter_date_from").val();
    }
    function getDateToShiftTable() {
        return $("input#" + IDENTIFIER + "_filter_date_to").val();
    }
    function getUserIdShiftTable() {
        return $("form#time_tracking_admin_tool_filter_form select.user_select").val();
    }

    function displayLoadingGifInButton() {
        fetchShiftsHtmlTableButton.html('<img src="/includes/charts/gfx/ajax-loader.gif" alt="Loading..." style="margin-right: 10px;"/> ' + translate('time_tracking_admin_fetching_data'));
    }

    function removeLoadingGifFromButton() {
        fetchShiftsHtmlTableButton.html(translate('update'));
    }

});
